import getEnv from './lib/getEnv';

export const ORN_ENV = getEnv('VITE_ORN_ENV') ?? 'dev';

export const IS_TEST = ORN_ENV === 'test';
export const IS_DEV = ORN_ENV === 'dev';
export const IS_STAGING = ORN_ENV === 'staging';
export const IS_PROD = ORN_ENV === 'prod';
